import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';

// init firebase database
const config = {
    apiKey: "AIzaSyBXNc1p5Y-GKGv4CwQkOy0VOsarVuhW5uw",
    authDomain: "guardian-bikes-app.firebaseapp.com",
    databaseURL: "https://guardian-bikes-app.firebaseio.com",
    projectId: "guardian-bikes-app",
    storageBucket: "guardian-bikes-app.appspot.com",
    messagingSenderId: "958831854934"
};

firebase.initializeApp(config);

const database = firebase.database();

const googleAuthProvider = new firebase.auth.GoogleAuthProvider();

const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();

export { firebase, googleAuthProvider, facebookAuthProvider, database as default}


// WEBPACK FOOTER //
// ./src/firebase/firebase.js